import { STAPE_GTM_ID } from '../../config';

interface CustomGTMLoaderBodyProps {
  domain: string;
}

const CustomGTMLoaderBody = (props: CustomGTMLoaderBodyProps) => {
  const { domain } = props;
  return (
    <noscript>
      <iframe
        title="custom-gtm-loader"
        src={`https://load.zahyqcrd.${domain}/ns.html?id=${STAPE_GTM_ID}`}
        height="0"
        width="0"
        style={{ display: 'none', visibility: 'hidden' }}
      ></iframe>
    </noscript>
  );
};

export default CustomGTMLoaderBody;
